import req from './http.js'

export const apiGetCard = (card_id, org_id) => req('get', '/card/card?org=' + org_id + '&id=' + card_id)

export const apiUpdateCard = (param, org_id, card_id) => req('put', '/card/card?org=' + org_id + '&id=' + card_id, param)

export const apiCreateCard = (org_id, param) => req('post', '/card/card?org=' + org_id, param)

export const apiDeleteCard = (card_id, org_id) => req('delete', '/card/card?org=' + org_id + '&id=' + card_id)

export const apiDeleteCardWithData = (card_id, org_id) => req(
    'delete', '/card/card?org=' + org_id + '&id=' + card_id
).then(function(resp){
    return resp.data
}).catch(function(error){
    throw error
})

export const apiGetCardContainer = (org_id) => req('get', '/card/container?org=' + org_id)

export const apiCreateCardContainer = (org_id, param) => req('post', '/card/container?org=' + org_id, param)

export const apiDeleteCardContainer = (container_id, org_id) => req('delete', '/card/container?org=' + org_id + '&containerId=' + container_id)

export const apiCardGetBy = (org_id, coupon_id, container_id, target_date, isCheck) => req('get', '/card/card/get/by?org=' + org_id + '&coupon_id=' + coupon_id + '&container_id=' + container_id + '&target_date=' + target_date + '&check=' + isCheck) 

export const apiCardGetByTags = (org_id, coupon_id, container_id, target_date, tags, end_at) => req('get', '/card/card/get/by?org=' + org_id + '&coupon_id=' + coupon_id + '&container_id=' + container_id + '&target_date=' + target_date + '&tags=' + tags + '&end_at=' + end_at)

export const apiCardGetByWithData = (org_id, coupon_id, container_id, target_date, end_at) => req('get', '/card/card/get/by?org=' + org_id + '&coupon_id=' + coupon_id + '&container_id=' + container_id + '&target_date=' + target_date + '&end_at=' + end_at).then(function(resp){
    return resp.data.data
}).catch(function(error){
    throw error
})

export const apiCardGetByTagsWithData = (org_id, coupon_id, container_id, target_date, tags, end_at) => req('get', '/card/card/get/by?org=' + org_id + '&coupon_id=' + coupon_id + '&container_id=' + container_id + '&target_date=' + target_date + '&tags=' + tags +  '&end_at=' + end_at).then(function(resp){
    return resp.data.data
}).catch(function(error){
    throw error
})


// 這2隻是一樣的api，搜尋條件不同
export const apiCardFindBy = (mode,page_idx, limit, key, container_id, org_id) => req(
    'get',
    `/card/card/find/by?containerId=${container_id}&org=${org_id}&page=${page_idx}&limit=${limit}&key=${key}&mode=${mode}`
).then(function(resp){
    return resp.data
}).catch(function(error){
    throw error
})

export const apiCardFindByTags = (container_id, org_id, tags) => req('get', '/card/card/find/by?containerId=' + container_id + '&org=' + org_id + '&tags=' + tags)

// 預覽api
export const apiGetPreviewToken  = (id, org_id) => req('get', `/card/preview?id=${id}&org=${org_id}`,null).then(function(resp){
    return resp.data.data
}).catch(function(error){
    throw error
})

// 複製圖卡
export const apiCopyCard = (params) => req(
    'post',
    `/card/card/copy?org=${params.org}&id=${params.id}`,
    params
).then(function(resp){
    return resp.data
}).catch(function(error){
    throw error
})

// 發布圖卡
export const apiReleaseCard = (org_id, id) => req(
    'patch',
    `/card/card/activate?id=${id}&org=${org_id}`
).then(function(resp){
    return resp.data
}).catch(function(error){
    throw error
})
// 取消發布圖卡
export const apiDisabledCard = (org_id, id) => req(
    'patch',
    `/card/card/deactivate?id=${id}&org=${org_id}`
).then(function(resp){
    return resp.data
}).catch(function(error){
    throw error
})

